import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import type { AppParam } from '@/navigation/types/navigation';

export const AppStack = createNativeStackNavigator<AppParam>();

export const TabStack = createBottomTabNavigator<AppParam>();
